module.exports = __webpack_public_path__ + "img/Stockroom Icon_Over.d75ce892.svg";